import { useState, useEffect } from "react";
import { ProviderContent } from "../../../class/iraQuestionnaire";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import Flex from "../../../layout/flex";
import ScrollableContainer from "../../../layout/scrollable-container";
import { getProviderContent } from "../../../utils/getProviderContent";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import {
  Dot,
  IRAPartnerContentSection,
  IRAPartnerMainContent,
  IRAProviderLogoDiv,
  Item,
  ItemContent,
  ItemDot,
} from "./styles";
import {
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS,
} from "../../../class/transferDetails";
import { TitleMedium, BodyMediumRegular, TitleLarge, BodyMediumBold } from "../../../components/font";
import { Button, HenryTips, tokens } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import { FooterButtonDiv } from "../../../components/footer/styles";

const IRAPartnerScreen = (props: UseExploreIRAOptionsType) => {
  const { currentScreen, iraRecommendationContent, goToScreen, onClickOpenAccount } = props;
  const [content, setContent] = useState<(ProviderContent & { isFeatured: boolean }) | null>(null);

  useEffect(() => {
    switch (currentScreen) {
      case STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY:
        setContent({
          ...getProviderContent("FUTURE_MONEY"),
          isFeatured: iraRecommendationContent?.FIRST.providerName === "Futuremoney",
        });
        break;
      case STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT:
        setContent({
          ...getProviderContent("BETTERMENT"),
          isFeatured: iraRecommendationContent?.FIRST.providerName === "Betterment",
        });
        break;
      case STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD:
        setContent({
          ...getProviderContent("ROBINHOOD"),
          isFeatured: iraRecommendationContent?.FIRST.providerName === "Robinhood",
        });
        break;
      case STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI:
        setContent({
          ...getProviderContent("SOFI"),
          isFeatured: iraRecommendationContent?.FIRST.providerName === "SoFi",
        });
        break;
    }
  }, []);
  if (!content) {
    return <></>;
  }
  return (
    <TransitionWrapper>
      <ScrollableContainer name="ira-partner">
        <Container>
          <IRAProviderLogoDiv $isLarge>
            <img src={content.logo} alt={content.providerName} />
          </IRAProviderLogoDiv>
          {content.isFeatured && (
            <>
              <Flex $flexDirection="column" $flexGap={20}>
                <Flex $flexDirection="column" $flexGap={10} $alignItems="flex-start">
                  <TitleLarge $textAlign="left">{content.providerName} IRA</TitleLarge>
                  <BodyMediumRegular $color={tokens.color.text.secondary}>{content.description}</BodyMediumRegular>
                </Flex>
                <HenryTips isBold className="justify-content--center">
                  Your match score: 98%
                </HenryTips>
              </Flex>
            </>
          )}
          <IRAPartnerMainContent>
            <IRAPartnerContentSection>
              <TitleMedium>Standout Features</TitleMedium>
              {content.standoutFeatures?.map((sf) => (
                <Item key={sf.heading}>
                  <ItemDot>
                    <Dot />
                  </ItemDot>
                  <ItemContent>
                    <BodyMediumBold>{sf.heading}</BodyMediumBold>
                    <BodyMediumRegular $color={tokens.color.text.secondary}>{sf.description}</BodyMediumRegular>
                  </ItemContent>
                </Item>
              ))}
            </IRAPartnerContentSection>
            <IRAPartnerContentSection>
              <TitleMedium>Who It’s Best For</TitleMedium>
              {content.whoItsBestFor?.map((bf) => (
                <Item key={bf.heading}>
                  <ItemDot>
                    <Dot />
                  </ItemDot>
                  <ItemContent>
                    <BodyMediumBold>{bf.heading}</BodyMediumBold>
                    <BodyMediumRegular $color={tokens.color.text.secondary}>{bf.description}</BodyMediumRegular>
                  </ItemContent>
                </Item>
              ))}
            </IRAPartnerContentSection>
            <IRAPartnerContentSection>
              <TitleMedium>Other Considerations</TitleMedium>
              {content.otherConsiderations?.map((bf) => (
                <Item key={bf.heading}>
                  <ItemDot>
                    <Dot />
                  </ItemDot>
                  <ItemContent>
                    <BodyMediumBold>{bf.heading}</BodyMediumBold>
                    <BodyMediumRegular $color={tokens.color.text.secondary}>{bf.description}</BodyMediumRegular>
                  </ItemContent>
                </Item>
              ))}
            </IRAPartnerContentSection>
          </IRAPartnerMainContent>
          {/* <IRAFeatureList>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>Best match with your investment style</BodyLargeBold>
            </IRAFeatureListItem>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>98% match with your priorities</BodyLargeBold>
            </IRAFeatureListItem>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>Offers the features you value</BodyLargeBold>
            </IRAFeatureListItem>
          </IRAFeatureList> */}
        </Container>
      </ScrollableContainer>

      <Footer>
        <FooterButtonDiv>
          <Button size="large" variant="secondary" onClick={() => goToScreen(STEP_DESTINATION_EXPLORE_IRA_OPTIONS)}>
            Go back
          </Button>
          <Button size="large" onClick={() => onClickOpenAccount(content.providerName || "")}>
            Open account
          </Button>
        </FooterButtonDiv>
      </Footer>
    </TransitionWrapper>
  );
};

export default IRAPartnerScreen;
